import { useLocation } from 'react-router-dom';

export const useSearchParams = () => new URLSearchParams(useLocation().search);
